import script from "./PerformanceCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./PerformanceCards.vue?vue&type=script&setup=true&lang=ts"

import "./PerformanceCards.vue?vue&type=style&index=0&id=36dc7f80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36dc7f80"]])

export default __exports__